import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'
import './index.css';
import Termine from './Termine';
import termineStore from './TermineStore'
import Referenten from "./Referenten"
import referentenStore from './ReferentenStore'

if (window.bbvTermine.mode === 'referenten') {
    ReactDOM.render(<Provider store={referentenStore}><Referenten /></Provider>, document.getElementById('biwe-referenten'));
} else {
    ReactDOM.render(<Provider store={termineStore}><Termine /></Provider>, document.getElementById('biwe-termine'));
}



// WEBPACK FOOTER //
// ./src/index.js